import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'


export  const StoresDropDownCleaningSchedule = (AuthDataStores,Authstr) => {

     const getUrl = environmentConfig();
     const requestUrl = getUrl+ ConstantsBase.VendorStoresDropDownCleaningSchedule+AuthDataStores

     try {
      const data =  axios({
        method: 'get',
        url: requestUrl,
        headers: { 'Content-Type': 'application/json;' , Authorization :Authstr },
        validateStatus: function (status) { return status >= 200 }
      })
      return data;
     }
     catch (e) {
      return e;
    }
}